import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useGetExpenseCategories } from "../../../../hooks/api/queries/useExpenses";
// import { getUrlQuerysection } from "../../../../helpers";

const useExpenseCategories = () => {
  // const queries = getUrlQuerysection();
  // const [metaDetails, setMetaDetails] = useState({});
  const [search, setSearch] = useSearchParams();
  const [isNewExpenseCategory, setIsNewExpenseCategory] = useState(false);

  const { isLoading: isFetchingCategories, data: expenseCategories } =
    useGetExpenseCategories();

  // const gotoPage = (pageNumber) => {
  //   search.set("page", pageNumber);
  //   setSearch(search, { replace: true });
  // };

  return {
    isFetchingCategories,
    expenseCategories: expenseCategories || [],
    // metaDetails,
    search,
    setSearch,
    isNewExpenseCategory,
    setIsNewExpenseCategory,
    // gotoPage,
  };
};

export default useExpenseCategories;
